const info = {
  appName: 'AlgoDriven Capture Application',
  shortName: 'AlgoDriven',
  companyName: 'AlgoDriven',
  logo: {
    source: {
      uri: 'logo_algodriven.png',
    },
    width: 160,
    height: 71,
  },
  description: 'AlgoDriven Capture App enables high level car inspections with helpers and specific user interfaces.',
  vm: true,
  resolution: 'FHD'
};

export default info;
